/**
 * Labstep
 *
 * @module prosemirror/nodes/experiment-step
 * @desc ExperimentStep node
 */

import { NodeKeys } from 'labstep-web/prosemirror/nodes/constants';
import { enterParagraphAfterStep } from 'labstep-web/prosemirror/nodes/protocol-step/commands';
import type { LabstepNode } from 'labstep-web/prosemirror/nodes/types';
import { getAttrsForId } from 'labstep-web/prosemirror/nodes/utils';
import type { Node as ProseMirrorNode } from 'prosemirror-model';

export const NodeStep: LabstepNode = {
  key: NodeKeys.experiment_step,
  spec: {
    attrs: {
      id: { default: null },
      guid: { default: null },
    },
    isolating: true,
    // defining: true,
    content: 'block+',
    group: 'step',
    draggable: true,
    parseDOM: [
      {
        tag: 'div',
        getAttrs: getAttrsForId(NodeKeys.experiment_step),
      },
    ],
    toDOM(node: ProseMirrorNode) {
      const { id, guid } = node.attrs;
      return [
        'div',
        {
          [`data-${NodeStep.key}-id`]: id,
          [`data-${NodeStep.key}-guid`]: guid,
        },
        0,
      ];
    },
  },
  keymap: {
    Enter: enterParagraphAfterStep,
  },
};
